"use client";

import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

interface DataPoint {
  name: string;
  agendamentos: number;
  faturamento: number;
}

interface AppointmentsAreaChartProps {
  data: DataPoint[];
}

export function AppointmentsAreaChart({ data }: AppointmentsAreaChartProps) {
  return (
    <ResponsiveContainer width="100%" height={280}>
      <AreaChart
        data={data}
        margin={{ top: 10, right: 10, left: -20, bottom: 0 }}
      >
        <defs>
          <linearGradient id="colorAgendamentos" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#C9A88E" stopOpacity={0.3} />
            <stop offset="95%" stopColor="#C9A88E" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid
          strokeDasharray="3 3"
          stroke="#f0f0f0"
          vertical={false}
        />
        <XAxis
          dataKey="name"
          axisLine={false}
          tickLine={false}
          tick={{ fill: "#636E72", fontSize: 12 }}
          dy={10}
        />
        <YAxis
          axisLine={false}
          tickLine={false}
          tick={{ fill: "#636E72", fontSize: 12 }}
          dx={-10}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: "#fff",
            border: "none",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            padding: "12px 16px",
          }}
          labelStyle={{ color: "#2D3436", fontWeight: 500, marginBottom: 4 }}
          itemStyle={{ color: "#636E72", fontSize: 13 }}
          formatter={(value) => [`${value} agendamentos`, ""]}
          labelFormatter={(label) => `${label}-feira`}
        />
        <Area
          type="monotone"
          dataKey="agendamentos"
          stroke="#C9A88E"
          strokeWidth={2.5}
          fill="url(#colorAgendamentos)"
          dot={{ fill: "#C9A88E", strokeWidth: 0, r: 4 }}
          activeDot={{ fill: "#C9A88E", strokeWidth: 0, r: 6 }}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}
